import { ContainerComponent, wrap } from 'AppReact';
import Controller from './controller';
import internalState from './internalState';
import { Mt8, Mx18, Mb8, Px6, FlexCenterWrapper, Mr2, Mt3, Mx3, Mt1, Mr3 } from 'wrappers';
import { SubscriptionHeaderFilter, RecurrenceSubscribeDropdown, TextSwitchButton } from 'containers';
import { SecondaryTextSmBold, CustomInput, RedTextSm } from 'atoms';
import { SolidButton, TextButton } from 'molecules';
import getIsMobile from "components/atoms/utils/getIsMobile";

const isMobile = getIsMobile();

let MarginFilter = isMobile ? Mx3 : Mx18;

export const definition = {
  name: 'Settings',
  controller: Controller,
  initialProps: ({ format, frequency, occurrenceValues, hour, minute, ampm, hidePdf, id }) => ({ format, frequency, occurrenceValues, hour, minute, ampm, hidePdf, id }),
  props: internalState,
  elements: [
    {
      wrapper: wrap(wrap(wrap(Mt8, Mb8), MarginFilter), Px6),
      name: '__transparent__',
      elements: [
        {
          component: SubscriptionHeaderFilter,
          name: 'FormatDropdown',
          bindings: ({ format, frequency, occurrenceValues, hour, minute, ampm, hidePdf }) => {
            return {
              label: 'Format ',
              format,
              selectedOptionIds: format ? [format] : [],
              placeholder: 'Select format',
              singleSelect: true,
              bold: true,
              frequency, occurrenceValues, hour, minute, ampm,
              options: hidePdf ? [{ id: 'csv', displayName: 'CSV', image: null }] : [{ id: 'pdf', displayName: 'PDF', image: null }, { id: 'csv', displayName: 'CSV', image: null }],
            }
          }
        },
        {
          component: wrap(RedTextSm, Mt1),
          name: 'FormatError',
          renderIf: ({ formatError }) => !!formatError,
          displayValue: ({ formatError }) => formatError
        },
        {
          component: wrap(SubscriptionHeaderFilter, Mt3),
          name: 'FrequencyDropdown',
          bindings: ({ frequency, occurrenceValues, format, hour, minute, ampm }) => {
            return {
              label: 'Frequency ',
              frequency,
              occurrenceValues,
              selectedOptionIds: frequency ? [frequency] : [],
              placeholder: 'Select frequency',
              singleSelect: true,
              format, hour, minute, ampm,
              bold: true,
              options: [
                { id: 'daily', displayName: 'Daily', image: null },
                { id: 'weekly', displayName: 'Weekly', image: null },
                { id: 'monthly', displayName: 'Monthly', image: null },
                { id: 'annually', displayName: 'Annually', image: null }
              ],
            }
          }
        },
        {
          component: wrap(RedTextSm, Mt1),
          name: 'FrequencyError',
          renderIf: ({ frequencyError }) => !!frequencyError,
          displayValue: ({ frequencyError }) => frequencyError
        },
        {
          component: wrap(RecurrenceSubscribeDropdown, Mt3),
          name: 'Recurrence',
          bindings: ({ frequency, occurrenceValues, format, hour, minute, ampm }) => ({
            frequency,
            format, hour, minute, ampm,
            label: 'On ',
            isReadonly: frequency === 'daily' || !frequency,
            placeholder: 'Select date/day',
            occurrenceValues,
          })
        },
        {
          component: wrap(RedTextSm, Mt1),
          name: 'OccurrenceError',
          renderIf: ({ occurrenceError }) => !!occurrenceError,
          displayValue: ({ occurrenceError }) => occurrenceError
        },
        {
          wrapper: wrap(FlexCenterWrapper, Mt3),
          name: 'TimeSelector',
          elements: [
            {
              component: wrap(SecondaryTextSmBold, Mr2),
              name: 'At',
              displayValue: ({ }) => 'At'
            },
            {
              component: wrap(CustomInput, Mr2),
              name: 'HourInput',
              bindings: ({ hour, format, frequency, occurrenceValues, minute, ampm }) => ({ value: hour ?? '', placeholder: "", format, frequency, occurrenceValues, minute, ampm }),
              displayState: ({ }) => ({ fontSize: '16px', width: '40px' }),
            },
            {
              component: wrap(SecondaryTextSmBold, Mr2),
              name: 'Dots',
              displayValue: ({ }) => ':'
            },
            {
              component: wrap(CustomInput, Mr2),
              name: 'MinuteInput',
              bindings: ({ minute, format, frequency, occurrenceValues, hour, ampm }) => ({ value: minute ?? '', placeholder: "", format, frequency, occurrenceValues, hour, ampm }),
              displayState: ({ }) => ({ fontSize: '16px', width: '40px' }),
            },
            {
              component: TextSwitchButton,
              name: 'AmPm',
              bindings: ({ ampm, format, frequency, occurrenceValues, hour, minute }) => ({ format, frequency, occurrenceValues, hour, minute, leftValue: { display: 'AM', id: 'am' }, rightValue: { display: 'PM', id: 'pm' }, selectedValueId: ampm })
            }
          ]
        },
        {
          component: wrap(RedTextSm, Mt1),
          name: 'TimeError',
          renderIf: ({ timeError }) => !!timeError,
          displayValue: ({ timeError }) => timeError
        },
        {
          wrapper: wrap(FlexCenterWrapper, Mt8),
          name: '__transparent__',
          elements: [
            {
              component: wrap(SolidButton, Mr3),
              name: 'Submit',
              bindings: ({ format, frequency, occurrenceValues, hour, minute, ampm, id }) => ({ format, frequency, occurrenceValues, hour, minute, ampm, title: id ? 'Update subscription' : 'Subscribe' }),
            },
            {
              name: 'Deactivate',
              component: TextButton,
              renderIf: ({ id }) => !!id,
              bindings: ({ id }) => ({ title: 'Deactivate subscription', id }),
            },
          ]
        },
      ]
    }
  ]
};

export default ContainerComponent(definition);